import React from "react";
import "./ProductDetail124.css";

function ProductDetail124() {
  return (
    <section className="challenges-section">

      <div className="challenges-container">

        <h2 className="challenges-title">
          Challenges in Traditional Toll Systems
        </h2>

        <p className="challenges-subtitle">
          Traditional toll collection systems face several operational and
          safety challenges that reduce efficiency and increase costs.
        </p>

        <div className="challenges-grid">

          <div className="challenge-card">
            <div className="challenge-icon"> <i className="bi bi-exclamation-triangle"></i></div>
            <h3>Manual errors in vehicle classification </h3>
            <p>
    Vehicle classification done manually leads to frequent errors,
    causing incorrect toll charges and inefficiencies.
  </p>
          </div>

          <div className="challenge-card">
            <div className="challenge-icon"><i className="bi bi-shield-x"></i></div>
            <h3>Fraudulent exemptions and misuse </h3>
            <p>
               Unauthorized exemptions and misuse of toll privileges result in
    revenue leakage and reduced system transparency.
            </p>
          </div>

          <div className="challenge-card">
            <div className="challenge-icon"><i className="bi bi-eye-slash"></i></div>
            <h3>Lack of real-time monitoring </h3>
            <p>
    Absence of real-time monitoring limits visibility and makes it
    difficult to track toll activity efficiently.
  </p>
          </div>

          <div className="challenge-card">
            <div className="challenge-icon"><i className="bi bi-wifi-off"></i></div>
            <h3>Inaccurate FASTag transactions</h3>
            <p>
    Transaction mismatches and delays in FASTag processing lead to
    billing errors and customer dissatisfaction.
  </p>
          </div>

          <div className="challenge-card">
            <div className="challenge-icon"><i className="bi bi-diagram-3"></i></div>
            <h3>No centralized control across toll plazas</h3>
            <p>
    Lack of centralized control makes managing multiple toll plazas
    difficult and inconsistent.
  </p>
          </div>

          <div className="challenge-card">
            <div className="challenge-icon"><i className="bi bi-clock-history"></i></div>
            <h3>Limited visibility into operations </h3>
            <p>
    Poor operational insights increase costs related to manpower,
    infrastructure, and maintenance.
  </p>
          </div>

        </div>

      </div>

    </section>
  );
}

export default ProductDetail124;